// @ts-nocheck: converted from JS

export const details = {
  volume: 'Volume',
  weight: 'Weight',
  width: 'Width',
  length: 'Length',
  depth: 'Depth',
};
